import React from "react";
import { useSelector } from "react-redux";
import TableInfo from "../../../../components/TableInfo";
import { isCustomPageSelector } from "../../../../ducks/profile";

const СlaimIncidents = props => {
    const { form } = props;
    
    const customPage = useSelector(state => isCustomPageSelector(state));

    return (
        <div className="tabs-card_table">
            <TableInfo
                key="claimIncidents"
                className='compact-container'
                headerRow={customPage.claimIncidentsColumns}
                list={form.incidents}
                isSubTable={true}
                canEdit={false}
            />
        </div>
    );
};

export default СlaimIncidents;